import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Estrutura de entrega',
  subtitle: 'Escolha como os pedidos são entregues (por localização).',
  form: {
    delivery_mode: {
      label: 'Modo de entrega',
      placeholder: 'Selecionar modo de entrega',
      options: {
        [DeliveryMode.Internal]: 'Interno (estafetas próprios)',
        [DeliveryMode.External]: 'Externo (terceiros)',
      },
    },
  },
  buttons: {
    back: 'Anterior',
    next: 'Seguinte',
    skip: 'Ignorar',
  },
  toasts: {
    error: 'Algo correu mal. Tente novamente.',
  },
};
